import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import {Show} from '../../Utils';

export default class Form extends React.Component {
  constructor() {
    super();

    this.state = {
      errorMsg: null,
    };

    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(e) {
    e.preventDefault();

    if (this.props.onSubmit) {
      const data = {};
      let foundErr = false;

      const inputs = e.target.getElementsByTagName('input');
      const textareas = e.target.getElementsByTagName('textarea');
      const selects = e.target.getElementsByTagName('select');

      const insertInputValue = (el) => {
        if (el.required && !el.value) {
          this.setState({errorMsg: 'Please fill out all required fields'});
          foundErr = true;
        }

        if (!el.name) {
          return;
        }

        const isCheckbox = (el.type === 'checkbox');
        const isRadio = (el.type === 'radio');
        let value = null;

        if (isCheckbox) {
          value = el.checked;
        } else if (isRadio) {
          // Only get the value of the radio button that is checked
          if (el.checked) {
            value = el.value;
          }
        } else {
          value = el.value;
        }

        if (value === null) {
          return;
        }

        _.set(data, el.name, value);
      };

      [].forEach.call(inputs, insertInputValue);
      [].forEach.call(textareas, insertInputValue);
      [].forEach.call(selects, insertInputValue);

      if (!foundErr) {
        this.props.onSubmit(data);
      }
    }
  }

  render() {
    return (
      <form onSubmit={this.onSubmit}>
        <Show condition={this.state.errorMsg}>
          <p className="info-box info-box--error">{this.state.errorMsg}</p>
        </Show>
        { this.props.children }
      </form>
    );
  }
}

Form.propTypes = {
  onSubmit: PropTypes.any,
  children: PropTypes.array,
};
